var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAgentWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 3.5C7.875 2.84375 7.5 2.23438 6.9375 1.88281C6.35156 1.55469 5.625 1.55469 5.0625 1.88281C4.47656 2.23438 4.125 2.84375 4.125 3.5C4.125 4.17969 4.47656 4.78906 5.0625 5.14062C5.625 5.46875 6.35156 5.46875 6.9375 5.14062C7.5 4.78906 7.875 4.17969 7.875 3.5ZM3 3.5C3 2.44531 3.5625 1.46094 4.5 0.921875C5.41406 0.382812 6.5625 0.382812 7.5 0.921875C8.41406 1.46094 9 2.44531 9 3.5C9 4.57812 8.41406 5.5625 7.5 6.10156C6.5625 6.64062 5.41406 6.64062 4.5 6.10156C3.5625 5.5625 3 4.57812 3 3.5ZM1.89844 11.375H10.0781C9.86719 9.89844 8.60156 8.75 7.05469 8.75H4.92188C3.375 8.75 2.10938 9.89844 1.89844 11.375ZM0.75 11.8203C0.75 9.5 2.60156 7.625 4.92188 7.625H7.05469C9.375 7.625 11.25 9.5 11.25 11.8203C11.25 12.1953 10.9219 12.5 10.5469 12.5H1.42969C1.05469 12.5 0.75 12.1953 0.75 11.8203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAgentWhite);
export default __webpack_public_path__ + "static/media/icon-agent-white.6e691b683d978dbf61838bca761e5dfb.svg";
export { ForwardRef as ReactComponent };